import React from "react";

const Over14Terms = () => {
  return (
    <div className="content">
      <p>INAVI Maps 서비스는 14세 이상 고객님만 가입을 하실 수 있습니다.</p>
      <p>따라서 14세 미만 고객님의 경우 본 서비스를 이용하실 수 없습니다.</p>
    </div>
  );
};

export default Over14Terms;
